import Vue from 'vue';
import MsgBoxVue from './Index.vue';
import PopPlugins from '@/utils/popPlugins';
import { MessageBoxImageType } from "@/constants/index";

const MessageBoxConstructor = Vue.extend(MsgBoxVue);

// 获取弹窗图片链接
function getMsgImg(options) {
	if (options.imageType == undefined) {
		return options;
	} else {
		options.msgImg = MessageBoxImageType.ImageMap[options.imageType];
		return options;
	}
}
const defaultOptions = {
	title: '',
	// 错误图片
	imageType: undefined,
	messageText: '',
	// 餐品列表
	messageList: [],
	showCancelBtn: false,
	showConfirmBtn: true,
	// 取消按钮文案
	cancelBtnText: '取消',
	// 确认按钮文案
	confirmBtnText: '确认',
	// 取消方法
	cancelFn(){},
	// 确认方法
	confirmFn(){},
	closeFn(){},
	showClose: false,
	msgTextClass: undefined
}

class MsgBox extends PopPlugins {
	constructor(name, vueConstructor, options) {
		super(name, vueConstructor);
		this.options = options;
	}
	init() {
		super.init();
	}
	show(options = {}) {
		let opt = Object.assign({}, this.options, getMsgImg(options));
		this.instance.showMsgBox(opt);
	}
	hide() {
		this.instance.closeMsgBox();
	}
}

const instance = new MsgBox('msgBox', MessageBoxConstructor, defaultOptions);
export default {
	install(Vue) {
		Vue.prototype.$msgbox = instance;
	}
}